import * as ambassadorWixPaymentsPlatformV1CheckoutSession from './payments-platform-v1-checkout-session-checkout-sessions.http.js';
import * as ambassadorWixPaymentsPlatformV1CheckoutSessionTypes from './payments-platform-v1-checkout-session-checkout-sessions.types.js';
import * as ambassadorWixPaymentsPlatformV1CheckoutSessionUniversalTypes from './payments-platform-v1-checkout-session-checkout-sessions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function generateCheckoutSession(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsPlatformV1CheckoutSessionUniversalTypes.GenerateCheckoutSessionRequest,
  ambassadorWixPaymentsPlatformV1CheckoutSessionTypes.GenerateCheckoutSessionRequest,
  ambassadorWixPaymentsPlatformV1CheckoutSessionUniversalTypes.GenerateCheckoutSessionResponse,
  ambassadorWixPaymentsPlatformV1CheckoutSessionTypes.GenerateCheckoutSessionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPlatformV1CheckoutSession.generateCheckoutSession(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout-sessions/generate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CheckoutSession as CheckoutSessionOriginal,
  GenerateCheckoutSessionRequest as GenerateCheckoutSessionRequestOriginal,
  SubscriptionInfo as SubscriptionInfoOriginal,
  SubscriptionSettings as SubscriptionSettingsOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  FreeTrialPeriod as FreeTrialPeriodOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  LineItem as LineItemOriginal,
  CustomerInfo as CustomerInfoOriginal,
  Cart as CartOriginal,
  CallbackUrls as CallbackUrlsOriginal,
  GenerateCheckoutSessionResponse as GenerateCheckoutSessionResponseOriginal,
  RegisterCheckoutSessionWebhookRequest as RegisterCheckoutSessionWebhookRequestOriginal,
  WebhookType as WebhookTypeOriginal,
  WebhookTypeWithLiterals as WebhookTypeWithLiteralsOriginal,
  RegisterCheckoutSessionWebhookResponse as RegisterCheckoutSessionWebhookResponseOriginal,
  GenerateCheckoutSessionApplicationErrors as GenerateCheckoutSessionApplicationErrorsOriginal,
} from './payments-platform-v1-checkout-session-checkout-sessions.types.js';
